import { Schema as S } from "effect";
export const Schema = S.String.pipe(S.brand("@open-revenue/schema/products/RecurringInterval"), S.annotations({
    title: "Recurring Interval",
    // Stripe docs say:  day, week, month or year
    description: "The interval of the recurring payment. Ex: 1 month = 'month', 3 months = 'month', 1 year = 'year'",
    // From Apple docs:
    // Possible durations are 1 week, 1 month, 2 months, 3 months, 6 months, and
    // 1 year. The duration can’t be changed after you submit for review.
    // https://developer.apple.com/help/app-store-connect/reference/auto-renewable-subscription-information/#:~:text=Possible%20durations%20are%201%20week%2C%201%20month%2C%202%20months%2C%203%20months%2C%206%20months%2C%20and%201%20year.%20The%20duration%20can%E2%80%99t%20be%20changed%20after%20you%20submit%20for%20review.
    examples: [
        "month",
        "day",
        "year"
    ]
}));
export const Strict = S.Union(S.Literal("day"), S.Literal("week"), S.Literal("month"), S.Literal("year")).pipe(S.brand("@open-revenue/schema/products/RecurringInterval"), S.annotations({
    title: "Recurring Interval (Strict)",
    description: "The interval of the recurring payment. Ex: 1 month = 'month', 3 months = 'month', 1 year = 'year'",
    examples: [
        "month",
        "day",
        "year"
    ]
}));
export const Day = "day";
export const DaysInYear = 365;
export const Week = "week";
export const WeeksInYear = 52;
export const Month = "month";
export const MonthsInYear = 12;
export const Year = "year";
export const make = (value)=>S.decodeUnknown(Schema)(value);
export const makeUnsafe = (value)=>value;
